import { render, staticRenderFns } from "./public-service.vue?vue&type=template&id=24296178"
import script from "./public-service.vue?vue&type=script&lang=js"
export * from "./public-service.vue?vue&type=script&lang=js"
import style0 from "./public-service.vue?vue&type=style&index=0&id=24296178&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports